import type { IndentationType } from './indentation-type';

export interface CodeFormat {
  indentationSize?: number;
  indentationType?: IndentationType;
  maxLineLength?: number | 'off';
}
